// method to check if value is boolean string
export const isBooleanString = (value) =>
	typeof value === 'string' &&
	(value.toLowerCase() === 'true' || value.toLowerCase() === 'false');
// method to clean HTML <br> tags from a string and replace them with newline characters
export const cleanHtmlBreaks = (text) => {
	if (!text) return '';
	return text.replace(/<br\s*\/?>/gi, '\n');
};
